<script>
import TreeMenu from "../../../components/treeMenu";
import appConfig from "../../../../app.config";
import Table from "../../../components/table";
import MessageAlert from "@/components/common/MessageAlert";
import _ from "loadsh";
import SwiperTool from "@/components/swiperTool.vue";
import {
  getModelList,
  getModelDetailId,
  deleteModelDetailId,
  putModel,
  getModelDevices,
} from "@/service/index";
import moment from "moment";
import "moment-timezone";
import Swal from "sweetalert2";
import {maintenanceItemList} from "@/utils/selectText";

export default {
  page: {
    title: "this.$t('page.product-info.name')",
    meta: [{ tag: 0, name: "description", content: appConfig.description }],
  },
  props: {
    showDetail: {
      type: Boolean,
      default: false,
    },
    currentNode: {
      type: Object,
      default: () => {},
    },
    currentType: {
      type: String,
      default: null,
    },
  },
  emits: ["update:showDetail", "initChartData"],
  data() {
    return {
      title: this.$t('menu.equipment-management.model-management.model'),
      items: [
        {
          text: this.$t('menu.equipment-management.model-management.text'),
        },
        {
          text: this.$t('menu.equipment-management.model-management.model'),
          active: true,
        },
      ],
      selected: "",
      modelList: [],
      originModelList: [], //保存一份原始数据，树结构搜索过滤使用
      tableData: [
        {
          name: this.$t('page.work-order.device.rated_voltage'),
          id: "yjrtyryrtkldkfo-jin9-409",
          newData: 677,
          unit: "v",
          update: "2022年3月23日 10:00:--（UTC+8:00）",
        },
        {
          name: this.$t('page.work-order.device.rated_voltage'),
          id: "yjrtyryrtkldkfo-jin9-409",
          newData: 677,
          unit: "v",
          update: "2022年3月23日 10:00:--（UTC+8:00）",
        },
        {
          name: this.$t('page.work-order.device.rated_voltage'),
          id: "yjrtyryrtkldkfo-jin9-409",
          newData: 677,
          unit: "v",
          update: "2022年3月23日 10:00:--（UTC+8:00）",
        },
        {
          name: this.$t('page.work-order.device.rated_voltage'),
          id: "yjrtyryrtkldkfo-jin9-409",
          newData: 677,
          unit: "v",
          update: "2022年3月23日 10:00:--（UTC+8:00）",
        },
      ],
      column: [
        { dataIndex: "name", title: this.$t('page.work-order.device.name') },
        //{ dataIndex: "id", title: "ID" },
        { dataIndex: "newData", title: this.$t('page.work-order.device.latest_value') },
        { dataIndex: "unit", title: this.$t('page.work-order.device.unit') },
        { dataIndex: "update", title: this.$t('page.work-order.device.latest_time') },
      ],
      emptyInfo: {
        title: this.$t('page.product-library.NoProductHasBeenCreated'),
        description: this.$t('page.product-library.YouCanCreateANewProduct'),
        icon: "bx bxs-error-circle",
      },
      modelSearchValue: "",
      viewType: false,
      detailInfo: {},
      //属性
      attributes: [],
      attributesColumn: [
        { dataIndex: "name", title: this.$t('page.work-order.device.name') },
        // { dataIndex: "id", title: "ID", width: "40%" },
        { dataIndex: "default", title: this.$t('page.product-library.DefaultVlue') },
        { dataIndex: "unit", title: this.$t('page.work-order.device.unit') },
        { dataIndex: "updateTime", title: this.$t('page.product-library.LatestTimestamp') },
      ],
      //测量值
      measurements: [],
      measurementsColumn: [
        { dataIndex: "name", title: this.$t('page.work-order.device.name') },
        // { dataIndex: "id", title: "ID", width: "40%" },
        { dataIndex: "unit", title: this.$t('page.work-order.device.unit') },
        { dataIndex: "dtype", title: this.$t('base.data_type') },
      ],
       fault_knowledge: [],
      faultKnowColumn: [
        { dataIndex: "manifest", title: this.$t('page.fault.fault_symptoms') },
        { dataIndex: "cause", title: this.$t('page.fault.fault_cause') },
        { dataIndex: "solution", title: this.$t('page.fault.resolution') },
      ],
      //维护保养
      repairs: [],
      displayRepairs: [],
      repairsColumn: [
        { dataIndex: "item_name", title: this.$t('page.tending.item'), width: "25%" },
        { dataIndex: "name", title: this.$t('page.tending.names'), width: "25%" },
        { dataIndex: "cycle", title: this.$t('page.tending.maintenance_period'), width: "25%" },
        { dataIndex: "description", title: this.$t('page.tending.description') },
      ],
      //标签
      tags: [],
      tagsColumn: [
        { dataIndex: "key", title: this.$t('page.work-order.device.name') },
        { dataIndex: "value", title: this.$t('page.work-order.value') },
      ],
      //资料库
      files: { image: [], video: [], document: [], '3d':[] },
      //物实例
      // instances: [],
      instancesCount: 0,
      instancesColumn: [
        { dataIndex: "name", title: this.$t('page.work-order.device-name') },
        { dataIndex: "updatedTime", title: this.$t('page.LastModificationTime') },
        { dataIndex: "createdTime", title: this.$t('page.DateCreated') },
      ],
      alertInfo: {
        content: "",
        variant: "danger",
        icon: "ri-error-warning-line",
      },
      formValidataAlert: false,
      searchType: true,
      page: 1,
      perPage: 20,
      pages: [],
      dataTypes: [
        { label: 5, value: 5 },
        { label: 10, value: 10 },
        { label: 15, value: 15 },
        { label: 20, value: 20 },
      ],
      tabActive: "attributes",
      showDelModal: false,
    };
  },
  components: {
    // Layout,
    TreeMenu,
    // Empty,
    // Multiselect,
    Table,
    MessageAlert,
    SwiperTool,
  },
  computed: {
    
    displayedPosts() {
      return this.paginate(this.modelList);
    },
    deleteTitle() {
      return this.$t('page.product-library.DeleteProduct') + (this.detailInfo && this.detailInfo.name || "")
    },
  },
  methods: {
       measurementsText(text){
           var name=''
        this.measurements.map(item=>{
            if(item.key==text){
               name=item.name
            }
        })
        return name
     },
    handlerClose() {
      this.$emit("update:showDetail", false);
      document
        .getElementsByTagName("body")[0]
        .classList.remove("overflow-hidden");
    },
    setPages() {
      let numberOfPages = Math.ceil(this.modelList.length / this.perPage);
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    paginate(data) {
      let page = this.page;
      let perPage = this.perPage;
      let from = page * perPage - perPage;
      let to = page * perPage;
      return data.slice(from, to);
    },
    moment,
    //递归数组
    recursionArr(data) {
      let result = [];
      let num = 0;
      let queue = data;
      while (queue.length > 0) {
        num += 1;
        [...queue].forEach((child, i) => {
          queue.shift();
          child.index = i;
          child.num = num;
          child.iconType = true;
          child["subId"] = "a" + child.id;
          result = result.concat([child]);
          child.children && queue.push(...child.children);
        });
      }
      return result.filter((item) => {
        return item.num == 1;
      });
    },
    getDetail(num) {
      // this.modelList = [];
      // this.originModelList = [];
      getModelList()
        .then((res) => {
          if (res.payload.data && res.payload.data.length > 0) {
            if (num) {
              this.getDetailId(res.payload.data[0]);
            }
            this.viewType = true;
            this.modelList = _.cloneDeep(this.recursionArr(res.payload.data));
            this.modelList.forEach((item) => {
              item.subId = "a" + item.id;
              item.num = 1;
            });
            this.originModelList = _.cloneDeep(this.modelList);
            this.setPages();
          }
          //   { tag: "1", subId: "id1", name: "1#轧机", num: 1 },
        })
        .catch(() => {
          this.viewType = false;
          this.handleAlert("danger", this.$t('page.product-library.FailedToGetProductList'));
        });
    },
    initData() {
      this.detailInfo = [];
      this.tags = [];
      this.attributes = [];
      this.measurements = [];
      this.repairs = [];
      this.displayRepairs = [];
      // this.instances = [];
      this.files = { image: [], video: [], document: [], '3d':[] };
    },
    getDetailId(obj, type) {
      if (obj) {
        this.selected = "a" + obj.id;
        this.initData();
        let params = {
          id: obj.id,
        };
        getModelDetailId(params)
          .then((res) => {
            if (res.payload) this.detailInfo = res.payload;
            if (res.payload.tags) this.tags = res.payload.tags;
            if (res.payload.repairs) {
              this.repairs = res.payload.repairs;
              this.displayRepairs = this.repairs.map(item => {
                const displayData = {
                  name: item.name,
                  item_name: item.item_name,
                  cycle: item.cycle,
                  description: item.description
                }
                const maintenanceItem = maintenanceItemList.find(m => m.value === item.name);
                if (maintenanceItem) {
                  displayData.name = maintenanceItem.label;
                  const cycleItem = maintenanceItem.cycleList.find(c => c.value === item.cycle);
                  if (cycleItem) {
                    displayData.cycle = cycleItem.label;
                  }
                }
                return displayData
              })
            }
            if (res.payload.files) this.files = res.payload.files;
            if (res.payload.fault_knowledge) this.fault_knowledge = res.payload.fault_knowledge;

            if (res.payload.attributes) {
              this.attributes = res.payload.attributes.attributes;
              this.attributes.map((item) => {
                if (item.createdTime)
                  item.createdTime = moment(item.createdTime).format(
                    "YYYY-MM-DD HH:mm:ss"
                  );
                if (item.updatedTime)
                  item.updatedTime = moment(item.updatedTime).format(
                    "YYYY-MM-DD HH:mm:ss"
                  );
              });
              this.measurements = res.payload.attributes.measurements;
              this.measurements.map((item) => {
                  
                if (item.createdTime)
                  item.createdTime = moment(item.createdTime).format(
                    "YYYY-MM-DD HH:mm:ss"
                  );
                if (item.updatedTime)
                  item.updatedTime = moment(item.updatedTime).format(
                    "YYYY-MM-DD HH:mm:ss"
                  );
              });
            }
            var box1 = document.getElementById(type || "attributesId");
            box1.click();
            //   { tag: "1", subId: "id1", name: "1#轧机", num: 1 },
          })
          .catch(() => {
            this.handleAlert("danger", this.$t('page.product-library.FailedToGetProductDetails'));
          });
      }
    },
    noDeleteModelDetail() {
      //   let toA = document.createElement("a");
      //   toA.href = "#instancesCard";
      //   toA.click();
      document.getElementById("instancesCard2").focus()
      // window.scrollBy(0, 190);
    },
    deleteModelDetail() {
      let params = {
        id: this.detailInfo.id,
      };
      deleteModelDetailId(params)
        .then((res) => {
          if (res.payload instanceof Array) {
            this.handleAlert(
              "danger",
              this.$t('page.product-library.ThisProductAssociatedInstance')
            );
          } else {
            this.handleAlert("success", this.$t('base.delete_success'), "ri-check-double-line");
            this.getDetail(1);
            // this.handlerClose();
            // this.$emit("initChartData");
          }
          //   { tag: "1", subId: "id1", name: "1#轧机", num: 1 },
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleAlert(
      variant = "danger",
      message = "",
      icon = "ri-error-warning-line",
      duration = "3000"
    ) {
      this.formValidataAlert = true;
      this.alertInfo.variant = variant;
      this.alertInfo.icon = icon;
      if (message) {
        this.alertInfo.content = message;
      }
      setTimeout(() => {
        this.formValidataAlert = false;
      }, duration);
    },
    //数组层深分级
    getDepth(json) {
      var arr = [];
      arr.push(json);
      var depth = 0;
      while (arr.length > 0) {
        var temp = [];
        for (var l = 0; l < arr.length; l++) {
          temp.push(arr[l]);
        }
        arr = [];
        for (var i = 0; i < temp.length; i++) {
          if (temp[i].children) {
            for (var j = 0; j < temp[i].children.length; j++) {
              arr.push(temp[i].children[j]);
            }
          }
        }
        if (arr.length >= 0) {
          depth++;
        }
      }
      return depth;
    },
    filterTree(nodes, query) {
      // 过滤关键字
      let predicate = (node) => {
        node["depth"] = this.getDepth(node);
        if (node.name.toLowerCase().indexOf(query.toLowerCase()) > -1) {
          return true;
        } else {
          return false;
        }
      };
      if (!(nodes && nodes.length)) {
        return [];
      }
      let newChildren = [];
      for (let node of nodes) {
        if (predicate(node)) {
          newChildren.push(node);
          node.children = this.filterTree(node.children, query);
        } else {
          newChildren.push(...this.filterTree(node.children, query));
        }
      }
      return newChildren.length ? newChildren : [];
    },
    modelSearch(e) {
      if (e.keyCode == 13) {
        e.cancelBubble = true;
        e.stopPropagation();
        e.preventDefault();
        if (
          this.filterTree(this.originModelList, this.modelSearchValue).length ==
          0
        ) {
          this.searchType = false;
        } else {
          this.searchType = true;
          this.modelList = this.filterTree(
            this.originModelList,
            this.modelSearchValue
          );
          this.setPages();
          this.getDetailId(this.modelList[0]);
          this.obj_model_id = this.modelList[0].id;
        }
        if (this.modelSearchValue.length == 0) {
          this.searchType = true;
          let modelId = _.get(this.$route, ["query", "model_id"]);
          if (modelId) {
            let params = {
              subId: "a" + modelId,
              id: modelId,
            };
            this.getDetail();
            this.getDetailId(params);
          } else {
            this.getDetail(1);
          }
        }
      }
    },
    searchThree(text) {
      if (this.filterTree(this.originModelList, text).length == 0) {
        this.searchType = false;
      } else {
        this.searchType = true;
        this.modelList = this.filterTree(this.originModelList, text);
        this.setPages();
        this.getDetailId(this.modelList[0]);
        this.obj_model_id = this.modelList[0].id;
      }
      if (text.length == 0) {
        this.searchType = true;
        let modelId = _.get(this.$route, ["query", "model_id"]);
        if (modelId) {
          let params = {
            subId: "a" + modelId,
            id: modelId,
          };
          this.getDetail();
          this.getDetailId(params);
        } else {
          this.getDetail(1);
        }
      }
    },
    // 删除知识库文件
    deleteFile(i, type) {
      let files = _.cloneDeep(this.files);
      files[type].splice(i, 1);
      let modelId = this.detailInfo.id;
      let params = {
        name: _.get(this.detailInfo, ["name"], ""),
        description: _.get(this.detailInfo, ["description"], ""),
        attributes: JSON.stringify({
          attributes: this.attributes,
          measurements: this.measurements,
        }),
        repairs: JSON.stringify(this.repairs),
        tags: JSON.stringify(this.tags),
        files: JSON.stringify(files),
        product_type: this.detailInfo.product_type,
      };
      console.log(params,"删除知识库文件,请求");
      // let a = 1 
      // if(a == 1) return;
      putModel(modelId, params).then((res) => {
        if (res && _.get(res, ["meta", "code"]) == 200) {
          if (modelId) {
            let params = {
              subId: "a" + modelId,
              id: modelId,
            };
            this.getDetail();
            this.getDetailId(params, "databaseId");
          } else {
            this.getDetail(1);
          }
          Swal.fire(this.$t('base.delete_success'));
        }
      });
    },
    editFile() {
      this.$router.push({
        path: "/model/form",
        query: {
          type: "edit",
          title: this.$t('page.product-library.EditProduct'),
          current_type: this.currentType,
          model_id: this.detailInfo.id,
        },
      });
    },
    //解决a标签锚点定位改变url问题
    goTab(idName) {
      this.tabActive = idName;
    },
    delStyle() {
      console.log(this.deleteTitle)
      this.showDelModal = true
      // document.getElementById("staticBackdrop").style.zIndex = "3000";
      // document.getElementsByClassName("modal-content")[0].style.zIndex = "3000";
    },
    // 获取模型关联设备列表
    async fetchModelDevices({ page, page_size }) {
      try {
        return await getModelDevices({
          page,
          page_size,
          model_id: this.detailInfo.id,
        });
      } catch (error) {
        console.error('Error fetching model devices:', error);
        return { payload: { results: [], count: 0 } };
      }
    },
  },
  mounted() {
    // let modelId = _.get(this.$route, ["query", "model_id"]);
    let modelId = _.get(this.currentNode, ["id"]);
    if (modelId) {
      this.page = localStorage.getItem("page") || this.page;
      this.perPage = localStorage.getItem("perPage") || this.perPage;
      let params = {
        subId: "a" + modelId,
        id: modelId,
      };
      this.getDetail();
      this.getDetailId(params);
    } else {
      this.getDetail(1);
    }
  },
  watch: {
    currentNode: {
      handler() {
        let modelId = _.get(this.currentNode, ["id"]);
        if (modelId) {
          this.page = localStorage.getItem("page") || this.page;
          this.perPage = localStorage.getItem("perPage") || this.perPage;
          let params = {
            subId: "a" + modelId,
            id: modelId,
          };
          this.getDetail();
          this.getDetailId(params);
        } else {
          this.getDetail(1);
        }
      },
      deep: true,
    },
    // showDetail: {
    //   handler() {
    //     // console.log(document.getElementById("staticBackdrop"));
    //     // document.getElementById("staticBackdrop").style.display = "none";
    //   },
    //   deep: true,
    // },
    files: {
      handler(newVal) {
        if (newVal.length) {
          newVal.forEach((item) => {
            let suffix = item.object_name.substring(
              item.object_name.lastIndexOf(".")
            );
            if (/\.(png|jpeg|jpg)$/.test(suffix)) {
              this.imagesList.push(item);
            } else if (/\.(ppt|pdf|xls|xlsx|doc|docx)$/.test(suffix)) {
              this.documentList.push(item);
            } else {
              this.videoList.push(item);
            }
          });
        }
        this.$emit("update:modelData.files", newVal);
      },
      deep: true,
    },
    modelSearchValue: {
      handler() {},
    },
    modelList() {
      this.pages = [];
      this.setPages();
    },
    perPage() {
      this.pages = [];
      this.page = 1;
      localStorage.setItem("perPage", this.perPage);
      localStorage.setItem("page", this.page);
      this.setPages();
    },
    page() {
      localStorage.setItem("page", this.page);
      localStorage.setItem("perPage", this.perPage);
    },
  },
};
</script>

<style scoped>
.page-class {
  min-height: 33.5px !important;
  padding: 0 !important;
}
</style>

<template>
  <div id="scrollBox">
    <!-- 详情 -->
    <div id="leftCard" style="width: 300px; flex: none; margin-right: 1.5rem">
      <div style="width: 300px; flex: none; margin-right: 1.5rem">
        <div class="card" style="width: 100%">
          <div
            class="card-body d-flex justify-content-between"
            style="padding-bottom: 0"
          >
            <p class="card-title" style="">{{ $t('page.products') }}</p>
            <router-link
              :to="{
                path: '/model/form',

                query: {
                  type: 'create',
                  title: this.$t('page.product-library.NewProduct'),
                  current_type: currentType,
                },
              }"
              class="btn btn-primary text-light"
              v-perm="'model.post'"
              ><i class="ri-add-line align-bottom me-1"></i
              >{{this.$t('page.product-library.CreateProduct')}}</router-link
            >
          </div>

          <div class="app-search d-md-block" style="margin: 0 20px">
            <div class="position-relative">
              <input
                type="text"
                class="form-control"
                :placeholder="this.$t('page.product-library.SearchForProductName')"
                autocomplete="off"
                id="search-options"
                v-model="modelSearchValue"
                @keydown="modelSearch"
              />
              <span class="mdi mdi-magnify search-widget-icon"></span>
              <span
                class="mdi mdi-close-circle search-widget-icon search-widget-icon-close d-none"
                id="search-close-options"
              ></span>
            </div>
          </div>

          <div>
            <div class="d-flex justify-content-between m-2 mt-0">
              <!-- <Multiselect
                :class="['form-control', 'page-class']"
                v-model="perPage"
                clear-on-select="false"
                :create-option="false"
                :options="dataTypes"
              /> -->
              <select
                style="width: 70px"
                class="form-select form-select-sm"
                v-model="perPage"
              >
                <option
                  class="option"
                  v-for="a in dataTypes"
                  :key="a.value"
                  :value="a.value"
                >
                  {{ a.label }}
                </option>
              </select>
              <div class="pagination-wrap hstack gap-2">
                <a
                  class="page-item pagination-prev"
                  href="javascript:void(0);"
                  @click="page != 1 && page--"
                >
                  <i class="bx bx-chevron-left"></i>
                </a>

                <ul class="pagination listjs-pagination mb-0">
                  <li
                    v-for="(pageNumber, index) in pages"
                    v-show="index < 2 || index == page - 1"
                    :class="{
                      active: pageNumber == page,
                      disabled: pageNumber == '...',
                    }"
                    :key="index"
                    @click="page = pageNumber"
                  >
                    <a class="page" href="javascript:void(0);">{{
                      pageNumber
                    }}</a>
                  </li>
                  <a
                    v-if="pages.length > 2 && page != pages[pages.length - 1]"
                    class="page"
                    href="javascript:void(0);"
                    >...</a
                  >
                </ul>
                <a
                  class="page-item pagination-next"
                  href="javascript:void(0);"
                  @click="page < pages.length && page++"
                >
                  <i class="bx bx-chevron-right"></i>
                </a>
              </div>
            </div>
            <div style="background: #e2e8ed" class="lh-lg p-1 ps-4 mb-2">
              {{this.$t('page.product-library.ProductName')}}
            </div>
            <b-form-group
              v-if="searchType"
              style="overflow: auto; max-height: 90vh"
            >
              <TreeMenu
                :selected="selected"
                :modelList="displayedPosts"
                @getDetailId="getDetailId"
                @getDetail="getDetail"
              />
            </b-form-group>
            <div v-if="!searchType" class="text-center text-black-50 m-2">
              {{this.$t('base.unmatched_data')}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="rightCard" style="height: 100vh" id="content-model">
      <div class="card">
        <div
          class="card-header d-flex justify-content-between align-items-center border-0 pb-0"
        >
          <h3>{{ detailInfo.name }}</h3>
          <div>
            <router-link
              :to="{
                path: '/model/form',
                query: {
                  type: 'edit',
                  title: this.$t('page.product-library.EditProduct'),
                  current_type: detailInfo.product_type,
                  model_id: detailInfo.id,
                },
              }"
              class="btn btn-primary waves-effect waves-light m-2 pe-4 ps-4 text-light"
              v-perm="'model.put'"
              ><i class="ri-pencil-fill align-bottom me-1"></i
              >{{this.$t('base.edit')}}</router-link
            >
            <button
              type="button"
              class="btn btn-primary waves-effect waves-light m-2 pe-4 ps-4"
              @click="delStyle"
              v-perm="'model.delete'"
            >
              <i class="ri-delete-bin-5-fill align-bottom me-1"></i>
              {{this.$t('base.delete')}}
            </button>
          </div>
        </div>
        <div class="card-header">
          <h6 class="card-title mb-0">{{this.$t('page.basic-info')}}</h6>
        </div>
        <div class="card-body m-2">
          <div class="row">
            <div class="col-4">
              <p>{{this.$t('page.ProductID')}}</p>
              <p>{{ detailInfo.id }}</p>
            </div>
            <div class="col-4">
              <p>{{this.$t('base.type')}}</p>
              <p>
                {{ detailInfo.product_type == "1" ? $t('page.work-order.device.single') : $t('page.work-order.device.unit_type') }}
              </p>
            </div>
            <div class="col">
              <p>{{this.$t('page.atlas-analysis.describe')}}</p>
              <p>
                {{ detailInfo.description }}
              </p>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-4">
              <p>{{ $t("base.import_pump") }}:</p>
              <p>
                {{
                  detailInfo.is_import_pump
                    ? $t("base.yes")
                    : $t("base.no")
                }}
              </p>
            </div>
            <div class="col">
              <p>{{ $t("base.iot_ready") }}:</p>
              <p>
                {{
                  detailInfo.is_iot_ready
                    ? $t("base.yes")
                    : $t("base.no")
                }}
              </p>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-4">
              <p>{{this.$t('base.last_modification_date')}}</p>
              <p>
                {{
                  (detailInfo.updatedTime &&
                    moment(detailInfo.updatedTime)
                      .tz($tz)
                      .format("YYYY-MM-DD HH:mm:ss")) ||
                  ""
                }}
              </p>
            </div>
            <div class="col">
              <p>{{this.$t('base.create_date')}}</p>
              <p>
                {{
                  (detailInfo.createdTime &&
                    moment(detailInfo.createdTime)
                      .tz($tz)
                      .format("YYYY-MM-DD HH:mm:ss")) ||
                  ""
                }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="card w-100">
        <div class="card-header m-2">
          <ul
            class="nav nav-tabs-custom rounded card-header-tabs nav-justified border-bottom-0 mx-n3"
            role="tablist"
          >
            <li class="nav-item">
              <a
                id="attributesId"
                :class="['nav-link', tabActive == 'attributes' && 'active']"
                data-bs-toggle="tab"
                :style="{
                  cursor: 'pointer',
                  color: tabActive == 'attributes' ? '#6691E7' : '#495057',
                }"
                @click="goTab('attributes')"
                role="tab"
              >
                {{this.$t('page.AttributeDefinition')}}
              </a>
            </li>
            <li class="nav-item">
              <a
                id="measurementsId"
                :class="['nav-link', tabActive == 'measurements' && 'active']"
                data-bs-toggle="tab"
                :style="{
                  cursor: 'pointer',
                  color: tabActive == 'measurements' ? '#6691E7' : '#495057',
                }"
                @click="goTab('measurements')"
                role="tab"
              >
                {{this.$t('page.MeasurementPoint')}}
              </a>
            </li>
            <li class="nav-item">
              <a
                :class="['nav-link', tabActive == 'cryptoSell' && 'active']"
                data-bs-toggle="tab"
                :style="{
                  cursor: 'pointer',
                  color: tabActive == 'cryptoSell' ? '#6691E7' : '#495057',
                }"
                @click="goTab('cryptoSell')"
                role="tab"
              >
                {{this.$t('page.tending.text')}}
              </a>
            </li>
            <li class="nav-item">
              <a
                :class="['nav-link', tabActive == 'faultKnow' && 'active']"
                data-bs-toggle="tab"
                :style="{
                  cursor: 'pointer',
                  color: tabActive == 'faultKnow' ? '#6691E7' : '#495057',
                }"
                @click="goTab('faultKnow')"
                role="tab"
              >
              {{ $t('page.fault.fault_knowledge_base') }}
              </a>
            </li>
            <li class="nav-item" v-perm="'model.document.get'">
              <a
                id="databaseId"
                :class="['nav-link', tabActive == 'databases' && 'active']"
                data-bs-toggle="tab"
                :style="{
                  cursor: 'pointer',
                  color: tabActive == 'databases' ? '#6691E7' : '#495057',
                }"
                @click="goTab('databases')"
                role="tab"
              >
                {{this.$t('base.data_bank')}}
              </a>
            </li>
          </ul>
        </div>
        <div class="card-body m-2">
          <div class="tab-content text-muted">
            <div
              :class="['tab-pane', tabActive == 'attributes' && 'active']"
              id="attributes"
              role="tabpanel"
            >
              <!-- Table Head -->
              <Table
                :tableData="attributes"
                :column="attributesColumn"
                :is-attributes="true"
              ></Table>
              <div
                v-if="attributes.length == 0"
                class="text-center text-black-50"
              >
             {{this.$t('page.NoAttributeDefinition')}}
              </div>
            </div>
            <!--end tab-pane-->
            <div
              :class="['tab-pane', tabActive == 'measurements' && 'active']"
              id="measurements"
              role="tabpanel"
            >
              <Table
                :tableData="measurements"
                :column="measurementsColumn"
              ></Table>
              <div
                v-if="measurements.length == 0"
                class="text-center text-black-50"
              >
                {{this.$t('page.NoMeasurementPoint')}}
              </div>
            </div>

            <div
              :class="['tab-pane', tabActive == 'cryptoSell' && 'active']"
              id="cryptoSell"
              role="tabpanel"
            >
              <Table :tableData="displayRepairs" :column="repairsColumn"></Table>
              <div
                v-if="displayRepairs.length == 0"
                class="text-center text-black-50"
              >
                {{this.$t('base.no_tending')}}
              </div>
            </div>
 <div
              :class="['tab-pane', tabActive == 'faultKnow' && 'active']"
              id="faultKnow"
              role="tabpanel"
            >
              <div
                v-for="(a, index) in fault_knowledge"
                :key="index"
                :class="['row', index != 0 && 'mt-2', index != 0 && 'pt-4']"
                style="border-bottom: 1px dotted #f2f3f4"
              >
                <div class="col-12 d-flex">
                  <div>
                    <div style="color:#212529">{{ $t('Fault Type') }}:</div>
                    <div class="mt-2">
                      <p style="color:#212529">{{ a.name }}</p>
                    </div>
                  </div>
                  <div class="ms-4">
                    <div style="color:#212529">{{ $t('page.fault.correlative_measuring_points') }}:</div>
                    <div class="mt-2">
                      <p>
                        <span
                          v-for="c in a.measurements"
                          :key="c"
                          class="me-2 badge bg-primary"
                          >{{ measurementsText(c) }}</span
                        >
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div style="color:#212529">{{ $t('page.fault.add_fault_description') }}</div>
                  <div
                    class="mt-3 mb-3"
                  >
                   <Table
                      :tableData="a.description"
                      :column="faultKnowColumn"
                    ></Table>
                    <div
                      v-if="a.description.length == 0"
                      class="text-center text-black-50"
                    >{{ $t('page.fault.no_fault_description') }}
                    </div>
                   
                  </div>
                </div>
              </div>
            </div>
            <!-- 资料库tab-内容 -->
            <div
              :class="['tab-pane', tabActive == 'databases' && 'active']"
              id="databases"
              role="tabpanel"
              v-perm="'model.document.get'"
            >
              <div class="p-2 w-100 text-body">
                <!-- 图片 -->
                <div class="w-100" v-show="files['image'].length">
                  <div>
                    <div class="border-primary fs-14 material-title">
                      {{this.$t('base.picture')}}
                    </div>
                  </div>
                  <div class="product-img-slider sticky-side-div ps-5 pe-5 swiper-parent">
                    <SwiperTool
                      :swiperInfo="{
                        type: 'image',
                        page: 'modeltag',
                        spaceBetween: 10,
                        slidesPerView: 10,
                        actionsClass: [
                          { name: 'ri-eye-fill', action: 'view' },
                          { name: 'ri-pencil-fill', action: 'edit' },
                          { name: 'ri-download-2-fill', action: 'download' },
                          { name: 'ri-delete-bin-5-fill', action: 'delete' },
                        ],
                      }"
                      :list="files['image']"
                      @deleteFile="deleteFile"
                      @editFile="editFile"
                    >
                    </SwiperTool>
                  </div>
                </div>
                <div class="mt-4 mb-4 w-100" v-show="files['video'].length">
                  <div>
                    <div class="border-primary fs-14 material-title">
                      {{this.$t('base.video')}}
                    </div>
                  </div>
                  <div class="product-img-slider sticky-side-div ps-5 pe-5 swiper-parent">
                    <SwiperTool
                      :swiperInfo="{
                        type: 'video',
                        page: 'modeltag',
                        spaceBetween: 10,
                        slidesPerView: 10,
                        actionsClass: [
                          { name: 'ri-play-circle-line', action: 'play' },
                          { name: 'ri-pencil-fill', action: 'edit' },
                          { name: 'ri-download-2-fill', action: 'download' },
                          { name: 'ri-delete-bin-5-fill', action: 'delete' },
                        ],
                      }"
                      :list="files['video']"
                      @deleteFile="deleteFile"
                      @editFile="editFile"
                    >
                    </SwiperTool>
                  </div>
                </div>
                <div class="w-100" v-show="files['document'].length">
                  <div>
                    <div class="border-primary fs-14 material-title">
                      {{this.$t('base.document')}}
                    </div>
                  </div>
                  <div class="product-img-slider sticky-side-div ps-5 pe-5 swiper-parent">
                    <SwiperTool
                      :swiperInfo="{
                        type: 'document',
                        page: 'modeltag',
                        spaceBetween: 10,
                        slidesPerView: 10,
                        actionsClass: [
                          { name: 'ri-eye-fill', action: 'view' },
                          { name: 'ri-pencil-fill', action: 'edit' },
                          { name: 'ri-download-2-fill', action: 'download' },
                          { name: 'ri-delete-bin-5-fill', action: 'delete' },
                        ],
                      }"
                      :list="files['document']"
                      @deleteFile="deleteFile"
                      @editFile="editFile"
                    >
                    </SwiperTool>
                  </div>
                </div>
                <div class="w-100" v-show="files['3d'].length">
                  <div>
                    <div class="border-primary fs-14 material-title">
                      {{ $t("模型") }}
                    </div>
                  </div>
                  <div class="product-img-slider sticky-side-div ps-5 pe-5 swiper-parent">
                    <SwiperTool
                      :swiperInfo="{
                        type: 'document',
                        page: 'modeltag',
                        spaceBetween: 10,
                        slidesPerView: 10,
                        actionsClass: [
                          { name: 'ri-eye-fill', action: 'view' },
                          { name: 'ri-pencil-fill', action: 'edit' },
                          { name: 'ri-download-2-fill', action: 'download' },
                          { name: 'ri-delete-bin-5-fill', action: 'delete' },
                        ],
                      }"
                      :list="files['3d']"
                      @deleteFile="deleteFile"
                      @editFile="editFile"
                    >
                    </SwiperTool>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card" style="width: 100%">
        <div class="card-header">
          <h6 class="card-title mb-0">{{this.$t('base.associated')}}</h6>
        </div>
        <div id="instancesCard2" class="card-body m-2" tabindex="998">
          <Table
            v-if="detailInfo.id"
            :column="instancesColumn"
            :paginate-by-api="true"
            :paginate-func="fetchModelDevices"
            detailRouter="/equipment-detail?equip_id"
            @page-data-loaded="(v) => instancesCount = v "
          ></Table>
          <div v-if="instancesCount == 0" class="text-center text-black-50">
            {{this.$t('base.no_associated')}}
          </div>
        </div>
      </div>
      <div class="card" style="width: 100%">
        <div class="card-header">
          <h6 class="card-title mb-0">{{this.$t('base.tag')}}</h6>
        </div>
        <div class="card-body m-2">
          <Table :tableData="tags" :column="tagsColumn"></Table>
          <div v-if="tags.length == 0" class="text-center text-black-50">
            {{this.$t('base.no_tag')}}
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- staticBackdrop Modal -->
  <b-modal
    v-model="showDelModal"
    :title="deleteTitle"
    header-class="mb-3 fs-16"
    body-class="text-center p-2 mb-2"
    footer-class="text-center p-2 mb-2 justify-content-center"
    centered
    size="md"
  >
    <div>
      <p class="fs-14 mb-2">
        <i style="color: #f06548" class="ri-error-warning-line"></i>
        <span v-if="instancesCount == 0">
          {{this.$t('page.delete_all_data')}}
        </span>
        <span v-else> {{this.$t('page.UndeletedInstancesCurrentProduct')}} </span>
      </p>
    </div>
    <template v-slot:footer>
      <div class="hstack gap-2 justify-content-center">
        <a
          href="javascript:void(0);"
          class="btn fw-medium btn-light"
          data-bs-dismiss="modal"
          >{{this.$t('base.cancel')}}</a
        >

        <a
          v-if="instancesCount == 0"
          href="javascript:void(0);"
          @click="deleteModelDetail"
          data-bs-dismiss="modal"
          class="btn btn-primary"
          >{{this.$t('base.done')}}</a
        >
        <a
          v-else
          data-bs-dismiss="modal"
          class="btn btn-primary"
          @click="noDeleteModelDetail"
          >{{this.$t('page.ViewingAssociatedDevices')}}</a
        >
      </div>
    </template>
  </b-modal>
  <MessageAlert :alertInfo="alertInfo" v-if="formValidataAlert"></MessageAlert>
</template>
<style lang="scss" scoped>
.model-detail {
  position: absolute;
  top: 130px;
  left: 0px;
  width: 100%;
  height: calc(100% - 220px);
  padding: 0 10px;
  .icon-close {
    display: flex;
    justify-content: flex-end;
    font-size: 24px;
    margin-right: 20px;
    cursor: pointer;
    display: none;
  }
}
.material-title {
  border-left: 3px solid;
  padding-left: 8px;
  height: 22px;
  line-height: 22px;
}

#scrollBox {
  background: #f3f6f9;
  padding: 30px 30px;
  display: flex;
  width: 100%;
  height: calc(100% - 270px);
  overflow: auto;
  z-index: 1060 !important;
  position: relative !important;
  #content-model {
    flex: 1;
  }
}
.swiper-parent {
  width: calc(100vw - 330px - 8.5rem);
}
</style>
